// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { color, hideElementOnPrint, xScreen } from "@ces/XDL/Utilities";
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { css } from "styled-components";

const overrideStyles = (isSelected?: boolean) => ({
    css: css`
        border-radius: 2px;
        img {
            max-width: 67px;
            max-height: 67px;
            width: 67px;
            height: 67px;
            padding: 0;

            ${isSelected &&
            css`
                width: 63px; // 67px - 4px border from both sides
                max-height: 63px;
                width: 63px;
                height: 63px;
            `};

            ${xScreen("lt", "md")} {
                max-width: 62px;
                max-height: 62px;
                width: 62px;
                height: 62px;
                ${isSelected &&
                css`
                    max-width: 58px;
                    max-height: 58px;
                    width: 58px;
                    height: 58px;
                `};
            }

            ${xScreen("lt", "sm")} {
                max-width: 70px;
                max-height: 70px;
                width: 70px;
                height: 70px;

                ${isSelected &&
                css`
                    max-width: 66px;
                    max-height: 66px;
                    width: 66px;
                    height: 66px;
                `};
            }
        }
        border: ${isSelected ? css`2px solid ${color("primary")}` : "none"};
    `,
});

productDetailsImageCarouselStyles.imageCarousel = {
    carouselWrapper: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
    carousel: {
        container: {
            css: css`
                margin-top: 16px;
            `,
        },
    },
    image: overrideStyles(),
    selectedImage: overrideStyles(true),
    carouselSlideInner: {
        css: css`
            padding: 0;
        `,
    },
} as any;
